/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

/** Common Components */
import Avatar from "../../../../../components/ui/avatar/Avtar";
import Iconify from "../../../../../layouts/components/iconify/iconify";
import FormCreator from "../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../components/ui/button/Buttons";

/** RTK Query */
import {
  useAddProjectTeamMutation,
  useDeleteProjectTeamMutation,
  useGetAllProjectTeamListMutation,
  useLazyGetUnAssginUserListQuery,
} from "../../../../../app/services/projectTeamManagementAPI";

/** Common Services & Data Files */
import SwalAlert from "../../../../../services/swalService/SwalService";
import ToastService from "../../../../../services/toastService/ToastService";
import { mapDropdownOptions } from "../../../../../components/finalForms/libs/mapDropdownOptions";

import { projectTeamMemberData } from "./ProjectTeamMember.data";

const ProjectTeam = (props) => {

  const projectTeamMemberRef = useRef();

  const { confirm } = SwalAlert();

  const [projectTeamGridData, setProjectTeamGridData] = useState([]);
  const [formData, setFormData] = useState({ ...projectTeamMemberData })

  // API'S Call
  const [getAllUsers, {
    isFetching: isUsersFetching,
    isSuccess: isUsersFetched,
    data: usersData
  },] = useLazyGetUnAssginUserListQuery();

  const [getAllProjectTeamList, {
    isSuccess: isProjectTeamListSuccess,
    data: isLProjectTeamListData,
  },] = useGetAllProjectTeamListMutation();

  const [deleteProjectTeam, {
    isSuccess: isDeleteSuccess,
    data: ProjectTeamDataDelete
  },] = useDeleteProjectTeamMutation();

  const [addProjectTeam, {
    isSuccess: isProjectTeamAdded,
    data: addProjectTeamData,
  },] = useAddProjectTeamMutation();

  //** useEffect's */
  useEffect(() => {
    getAllUsers(props.projectId);
  }, [props.projectId]);

  useEffect(() => {
    getProjectTeamDataList(props.projectId);
  }, [props.projectId]);

  useEffect(() => {
    if (!isUsersFetching && isUsersFetched && usersData) {
      const updatedFormData = { ...projectTeamMemberData }
      mapDropdownOptions(
        updatedFormData,
        "TeamMember",
        "userId",
        usersData,
        "userId",
        "userName"
      );
      setFormData(updatedFormData)
    }
  }, [isUsersFetching, isUsersFetched, usersData]);

  useEffect(() => {
    if (isProjectTeamListSuccess && isLProjectTeamListData) {
      if (isLProjectTeamListData) {
        setProjectTeamGridData(isLProjectTeamListData.dataSource);
      }
    }
  }, [isProjectTeamListSuccess, isLProjectTeamListData]);

  useEffect(() => {
    if (isProjectTeamAdded && addProjectTeamData) {
      if (addProjectTeamData.errorMessage.includes("exists")) {
        ToastService.warning(addProjectTeamData.errorMessage);
        return;
      } else {
        ToastService.success(addProjectTeamData.errorMessage);
        getProjectTeamDataList();
        getAllUsers(props.projectId);
      }
    }
  }, [isProjectTeamAdded, addProjectTeamData]);

  useEffect(() => {
    if (isProjectTeamListSuccess && isLProjectTeamListData) {
      if (isLProjectTeamListData) {
        setProjectTeamGridData(isLProjectTeamListData.dataSource);
      }
    }
  }, [isProjectTeamListSuccess, isLProjectTeamListData]);

  useEffect(() => {
    if (isDeleteSuccess && ProjectTeamDataDelete) {
      ToastService.success(ProjectTeamDataDelete.errorMessage);
      getProjectTeamDataList();
      getAllUsers(props.projectId);
      resetForm();
    }
  }, [isDeleteSuccess, ProjectTeamDataDelete]);

  //** Funcation's */
  const resetForm = () => {
    const form = {...projectTeamMemberData}
    form.initialState = {...projectTeamMemberData.initialState};
    setFormData(form);
  }

  const getProjectTeamDataList = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 40,
      },
      filters: {
        searchText: props.search,
      },
      projectId: props.projectId,
    };
    getAllProjectTeamList(request);
  };

  const handleSubmit = () => {
    const teamMemberData = projectTeamMemberRef.current.getFormData();
    if (teamMemberData) {
      const userIds = teamMemberData.userId.join(",");

      const requestData = {
        projectId: props.projectId,
        UserIds: userIds,
      };

      addProjectTeam(requestData);
      resetForm();
    }
  }

  const onDeleteClick = (id) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteProjectTeam(id);
      }
    });
  };

  return (
    <div>
      <div className="team-member-sec">
        <div className="select-team-member row">
          <div className="col-lg-3 col-md-3">
            <div className="form-card row">
              <FormCreator config={formData} ref={projectTeamMemberRef} />
            </div>
          </div>

          <div className="col-lg-6 col-md-6 mt-4">
            <Buttons
              buttonTypeClassName="theme-btn ml-4"
              buttonText="Add"
              onClick={() => handleSubmit()}
            />
          </div>
        </div>

        <div className="row team-member-list mt-1">
          {projectTeamGridData?.map((member, index) => (
            <div className="col-3" key={index + 1}>
              <div className="main-project-team-card">
                <div className="project-team-member-card">
                  <div className="project-team-member-card__profile">
                    <div className="project-top-bar">
                      <div
                        className="avatar-sec"
                        style={{ position: "relative" }}
                      >
                        <Avatar
                          alt={member.userName}
                          size="small"
                          shape="circle"
                          tooltip={false}
                        />
                        <div className="project-team-member-card__status active"></div>
                      </div>
                      <div className="name-sec">
                        <div className="project-team-member-card__username">
                          {member.userName}
                        </div>
                        <div className="project-team-member-card__info">
                          <div className="project-team-member-card__userrole"></div>
                          <div className="project-team-member-card__email">
                            {member.roleName} | {member.emailAddress}
                          </div>
                        </div>
                      </div>
                      {member.userId === member.responsibleUserId ? (
                        <div className='project-team-member-card__admin'>
                          <Iconify icon="eos-icons:admin-outlined" />
                        </div>
                      ) : (
                        <button
                          className="delete-icon"
                          title="DELETE"
                          onClick={() =>
                            onDeleteClick(member.projectTeamManagementId)
                          }
                        >
                          <Iconify icon="mingcute:delete-2-line" />
                        </button>
                      )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

ProjectTeam.propTypes = {
  projectId: PropTypes.number,
  search: PropTypes.string  
};

export default ProjectTeam;
